import React from "react";
import { connect } from "react-redux";
import "./TocEditPanel.css";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import Alert from "react-bootstrap/Alert";
import { withCookies } from "react-cookie";
import Draggable from "react-draggable";
import {
  loadArticlesRequestAction,
  recoverLastMoveAction,
  mergeTocArticleRequestAction,
  saveTocRequestAction,
  createManualArticleAction,
  setLockingIDAction,
  saveTempTocAction,
  changeTocModeAction,
  saveIssueDesRequestAction,
  enterIssueDescriptionAction
} from "../../redux/actions/tocEditPanel";
import TocListItem from "../TocListItem/TocListItem";
import { generateUniqueID } from "../../utils/utils";

class TocEditPanel extends React.Component {
  constructor(props) {
    super(props);
    this.handleResize = this.handleResize.bind(this);
    this.getPanelPos = this.getPanelPos.bind(this);
    this.recoverClicked = this.recoverClicked.bind(this);
    this.saveClicked = this.saveClicked.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.mergeToc = this.mergeToc.bind(this);
    this.createClicked = this.createClicked.bind(this);
    this.updateScrollTop = this.updateScrollTop.bind(this);
    this.deleteScrollTop = this.deleteScrollTop.bind(this);
    this.setCurDragY = this.setCurDragY.bind(this);
    this.modeClicked = this.modeClicked.bind(this);
    this.onDesChange = this.onDesChange.bind(this);
    this.deleteDesClicked = this.deleteDesClicked.bind(this);
    this.messagesEnd = React.createRef();
    this.tocPanelRef = React.createRef();
    this.tocPanelBodyRef = React.createRef();

    this.scrollTops = {};
    this.curDragY = -1;

    this.state = {
      windowHeight: window.innerHeight,
      highlightArticle: null
    };
  }

  modeClicked(newMode) {
    const { mode, changeTocModeAction } = this.props;

    if (mode === newMode) {
      return;
    }

    changeTocModeAction({ mode: newMode });
  }

  updateScrollTop(idx, positionData, oldIdx) {
    this.scrollTops[idx] = positionData;

    if (oldIdx != null && oldIdx !== idx && this.scrollTops[oldIdx] != null) {
      if (this.scrollTops[oldIdx].id === positionData.id) {
        delete this.scrollTops[oldIdx];
      }
    }
  }

  deleteScrollTop(idx, positionData) {
    if (this.scrollTops[idx] != null) {
      if (this.scrollTops[idx].id === positionData.id) {
        delete this.scrollTops[idx];
      }
    }
  }

  createClicked() {
    if (this.props.isSaveLoading) {
      return;
    }

    const newID = generateUniqueID();
    this.props.createManualArticleAction({
      newID,
      insertIndex: 0
    });

    this.props.setLockingIDAction({ lockingID: newID });
    this.props.saveTempTocAction(this.props.issueID);
  }

  setCurDragY(y) {
    if (this.props.isSaveLoading) {
      return;
    }

    this.curDragY = y;
    const highlightArticle = getHighlightArticle(
      this.curDragY,
      this.scrollTops
    );

    if (highlightArticle !== this.state.highlightArticle) {
      this.setState({ highlightArticle: highlightArticle });
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);

    const {
      issueID,
      loadedIssueID,
      loadArticlesRequestAction,
      enterIssueDescriptionAction,
      issue
    } = this.props;

    if (issueID !== loadedIssueID) {
      loadArticlesRequestAction(issueID);
    }

    enterIssueDescriptionAction({ description: issue.description });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  recoverClicked() {
    if (this.props.isSaveLoading) {
      return;
    }

    this.props.recoverLastMoveAction();
    this.props.saveTempTocAction(this.props.issueID);
  }

  saveClicked() {
    const {
      issueID,
      articleIDs,
      saveTocRequestAction,
      saveIssueDesRequestAction,
      issue,
      mode,
      description
    } = this.props;

    if (articleIDs == null || issue == null) {
      return;
    }

    if (mode === "toc") {
      if (window.confirm("Save TOC?") !== true) {
        return;
      }

      saveTocRequestAction(issueID, articleIDs, issue.pages.length, toast);
    } else {
      if (window.confirm("Save Issue Description?") !== true) {
        return;
      }

      saveIssueDesRequestAction(issueID, issue, description, toast);
    }
  }

  mergeToc(fromArticle, concatOnly) {
    if (this.props.isSaveLoading) {
      return;
    }

    const { highlightArticle } = this.state;
    const { mergeTocArticleRequestAction, issueID } = this.props;

    if (
      fromArticle != null &&
      highlightArticle != null &&
      fromArticle.id !== highlightArticle.id
    ) {
      setTimeout(() => {
        mergeTocArticleRequestAction(
          fromArticle,
          highlightArticle,
          issueID,
          concatOnly
        );
      }, 10);

      return true;
    }

    return false;
  }

  getPanelPos() {
    if (this.tocPanelRef == null) {
      return { x: 0, y: 0 };
    }

    let panelRect = this.tocPanelRef.getBoundingClientRect();

    let scrollTop =
      this.tocPanelBodyRef == null ? 0 : this.tocPanelBodyRef.scrollTop;

    return {
      x: panelRect.x,
      y: panelRect.y,
      scrollTop: scrollTop
    };
  }

  handleResize() {
    this.setState({
      windowHeight: window.innerHeight
    });
  }

  deleteDesClicked() {
    this.props.enterIssueDescriptionAction({ description: "" });
  }

  onDesChange(e) {
    this.props.enterIssueDescriptionAction({ description: e.target.value });
  }

  renderDescription() {
    const { isSaveLoading, description } = this.props;

    return (
      <Card text="dark" bg="warning" className="toc_list_card no_move_panel">
        <Card.Header style={{ paddingTop: "5px", paddingBottom: "5px" }}>
          Description
          <Button
            disabled={isSaveLoading}
            variant="primary"
            size="sm"
            className="toc_delete_btn"
          >
            <span className="fa fa-lock" />
          </Button>
          <Button
            disabled={isSaveLoading}
            variant="danger"
            size="sm"
            className="toc_delete_btn"
            onClick={this.deleteDesClicked}
          >
            <span className="fa fa-eraser" />
          </Button>
        </Card.Header>
        <Card.Body style={{ paddingTop: "0", paddingBottom: "0" }}>
          <Row>
            <Col
              style={{ padding: "5px", paddingLeft: "0", paddingRight: "0" }}
            >
              <Form.Control
                as="textarea"
                size="sm"
                type="text"
                style={{ height: 500 }}
                value={description}
                onChange={this.onDesChange}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }

  renderSwitch() {
    const { errMsg, articleIDs, issueID, mode, issue } = this.props;
    const { highlightArticle } = this.state;
    const highlightID = highlightArticle == null ? null : highlightArticle.id;

    if (errMsg != null) {
      return <Alert variant="danger">{errMsg}</Alert>;
    } else if (mode !== "toc") {
      return this.renderDescription();
    } else {
      return (
        <div className="no_move_panel">
          {articleIDs.map((anArticleID, idx) => (
            <TocListItem
              key={anArticleID}
              idx={idx + 1}
              articleID={anArticleID}
              getPanelPosition={this.getPanelPos}
              shouldHighlight={anArticleID === highlightID}
              mergeToc={this.mergeToc}
              updateScrollTop={this.updateScrollTop}
              deleteScrollTop={this.deleteScrollTop}
              setCurDragY={this.setCurDragY}
              issueID={issueID}
              maxPage={issue == null ? 1 : issue.pages.length}
            />
          ))}
        </div>
      );
    }
  }

  scrollToBottom() {
    if (this.messagesEnd != null) {
      this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
  }

  componentDidUpdate(prevProps) {
    const { lastAppendTime } = this.props;

    if (lastAppendTime !== prevProps.lastAppendTime) {
      this.scrollToBottom();
    }
  }

  render() {
    const {
      issueID,
      loadedIssueID,
      articleIDs,
      disableRecover,
      isSaveLoading,
      mode
    } = this.props;

    const isLoading = issueID !== loadedIssueID || articleIDs == null;

    const isTocMode = mode === "toc";

    const { cookies } = this.props;
    const isAdmin = cookies.get("role") === "admin";

    return (
      !isLoading && (
        <Draggable
          handle=".handle"
          cancel=".no_move_panel"
          defaultPosition={{ x: 0, y: 0 }}
        >
          <Card
            ref={el => (this.tocPanelRef = el)}
            bg="info"
            text="white"
            style={{
              width: "300px",
              height: this.state.windowHeight - 10,
              position: "fixed",
              top: "5px",
              right: "5px"
            }}
          >
            <Card.Header className="handle">
              <ButtonGroup
                variant="light"
                className="article_toc_control_btns no_move_panel"
              >
                <Button
                  disabled={isSaveLoading}
                  variant={isTocMode ? "success" : "light"}
                  size="sm"
                  className="article_toc_control_btns no_move_panel"
                  onClick={() => this.modeClicked("toc")}
                >
                  <span className="fa fa-list" />
                </Button>
                <Button
                  disabled={isSaveLoading || !isAdmin}
                  variant={!isTocMode ? "success" : "light"}
                  size="sm"
                  className="article_toc_control_btns no_move_panel"
                  onClick={() => this.modeClicked("description")}
                >
                  <span className="fa fa-info-circle" />
                </Button>
              </ButtonGroup>

              {isTocMode && (
                <Button
                  variant="primary"
                  size="sm"
                  disabled={disableRecover || isSaveLoading}
                  className="toc_recover_btn no_move_panel"
                  onClick={this.recoverClicked}
                >
                  <span className="fa fa-undo" />
                </Button>
              )}
              <Button
                disabled={isSaveLoading}
                variant="success"
                size="sm"
                className="toc_recover_btn no_move_panel"
                onClick={this.saveClicked}
              >
                {isSaveLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <span className="fa fa-save" />
                )}
              </Button>
              {isTocMode && (
                <Button
                  disabled={isSaveLoading}
                  variant="warning"
                  size="sm"
                  className="toc_recover_btn no_move_panel"
                  onClick={this.createClicked}
                >
                  <span className="fa fa-plus" />
                </Button>
              )}
            </Card.Header>
            <Card.Body
              ref={el => (this.tocPanelBodyRef = el)}
              className="edit_toc_list handle"
              style={{ paddingRight: "5px", paddingLeft: "5px" }}
            >
              {this.renderSwitch()}
              <div
                ref={el => {
                  this.messagesEnd = el;
                }}
              />
            </Card.Body>
          </Card>
        </Draggable>
      )
    );
  }
}

function getHighlightArticle(curDragY, scrollTops) {
  const idxArr = Object.keys(scrollTops);

  const highlightArr = idxArr.filter(i => {
    if (scrollTops[i] == null) {
      return false;
    }

    return (
      scrollTops[i].topBound <= curDragY && curDragY <= scrollTops[i].btmBound
    );
  });

  let highlightArticle = null;

  if (highlightArr.length > 0) {
    highlightArticle = scrollTops[highlightArr[0]].article;
  }

  return highlightArticle;
}

const mapState = state => {
  const { tocEditPanel } = state;
  const { editHistory } = tocEditPanel;

  let articleIDs = null;

  if (editHistory.length > 0) {
    articleIDs = editHistory[editHistory.length - 1].articleIDs;
  }

  return {
    loadedIssueID: tocEditPanel.loadedIssueID,
    mode: tocEditPanel.mode,
    errMsg: tocEditPanel.errMsg,
    articleIDs: articleIDs,
    disableRecover: editHistory.length <= 1,
    lastAppendTime: tocEditPanel.lastAppendTime,
    isSaveLoading: tocEditPanel.isSaveLoading,
    description: tocEditPanel.description
  };
};

const mapDispatch = {
  loadArticlesRequestAction,
  recoverLastMoveAction,
  mergeTocArticleRequestAction,
  saveTocRequestAction,
  createManualArticleAction,
  setLockingIDAction,
  saveTempTocAction,
  changeTocModeAction,
  saveIssueDesRequestAction,
  enterIssueDescriptionAction
};

export default withCookies(
  connect(
    mapState,
    mapDispatch
  )(TocEditPanel)
);
